import ServerInformationsStatus from "./ServerInformationsStatus";
import ServerInformationsDisplay from "./ServerInformationsDisplay";
import { Component } from "solid-js";

const ServerInformations: Component = () => {
  return (
    <>
      <ServerInformationsDisplay/>
      <ServerInformationsStatus/>
    </>
  );
};

export default ServerInformations;
